import React, { useState, useEffect } from "react";
import { Col, Table, Row, Image, Button, Modal } from "react-bootstrap";
import moment from "moment";
import LocationReusable from "../../../reusableComponents/allPopupReusable/locationReusablePopup/LocationReusable";
import { NEW_PAYMENT_TYPE } from "../../../../enums/OrderEnums";
import ExpEditWaitTime from "./Modals/ExpEditWaitTime";
import NewCountDown from "../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import { amApi } from "../../../../api/apiHelper";
import { errorAlert } from "../../../../function/alert";
import { QRCode } from "react-qr-svg";
import ShareButtonExpTicket from "./ShareButtonExpTicket";

const statusName = {
  PENDING: {
    name: "Pending",
    background: "#FFF6DF",
    color: "#E2A200",
    sideBar: "#FCB62B",
  },
  NOTSEATED: {
    name: "Not Seated",
    background: "#FBEABF",
    color: "#C18A00",
    sideBar: "#FCB62B",
  },
  SEATED: {
    name: "Seated",
    background: "#e6ffdf",
    color: "#25A900",
    sideBar: "#37AC1E",
  },
  COMPLETED: {
    name: "Completed",
    background: "#e6ffdf",
    color: "#25A900",
    sideBar: "#37AC1E",
  },
  CANCELLED: {
    name: "Cancelled",
    background: "#ffdfdf",
    color: "#ee3a23",
    sideBar: "#FFFFFF",
  },
  REJECTED: {
    name: "Rejected",
    background: "#ffdfdf",
    color: "#ee3a23",
    sideBar: "#FFFFFF",
  },
};

const statusBackIcon = {
  PENDING: require("../../../../assets/images/iconButton/cancelButton.svg"),
  NOTSEATED: require("../../../../assets/images/iconButton/backarrowred.svg"),
  SEATED: require("../../../../assets/images/iconButton/backarrowred.svg"),
  COMPLETED: require("../../../../assets/images/iconButton/reset-button.png"),
  CANCELLED: require("../../../../assets/images/iconButton/reset-button.png"),
  REJECTED: require("../../../../assets/images/iconButton/reset-button.png"),
};

const ViewExpReqDetails = ({
  dataSend,
  viewOnScan,
  hidden,
  btnData,
  onBack,
  onNext,
  page,
  resetScan,
  onClickPayLater,
  ...props
}) => {
  const [showView, setShowView] = useState(false);
  const handleCloseView = () => {
    setShowView(false);
    if (resetScan) resetScan();
  };
  const handleShowView = () => {
    setShowView(true);
  };

  const statusName = {
    PENDING: {
      name: "Pending",
      background: "#FFF6DF",
      color: "#E2A200",
      sideBar: "#FCB62B",
    },
    NOTSEATED: {
      name: "Not Seated",
      background: "#FBEABF",
      color: "#C18A00",
      sideBar: "#FCB62B",
    },
    SEATED: {
      name: "Seated",
      background: "#e6ffdf",
      color: "#25A900",
      sideBar: "#37AC1E",
    },
    COMPLETED: {
      name: "Completed",
      background: "#e6ffdf",
      color: "#25A900",
      sideBar: "#37AC1E",
    },
    CANCELLED: {
      name: "Cancelled",
      background: "#ffdfdf",
      color: "#ee3a23",
      sideBar: "#FFFFFF",
    },
    REJECTED: {
      name: "Rejected",
      background: "#ffdfdf",
      color: "#ee3a23",
      sideBar: "#FFFFFF",
    },
  };

  const statusBackIcon = {
    PENDING: require("../../../../assets/images/iconButton/cancelButton.svg"),
    NOTSEATED: require("../../../../assets/images/iconButton/backarrowred.svg"),
    SEATED: require("../../../../assets/images/iconButton/backarrowred.svg"),
    COMPLETED: require("../../../../assets/images/iconButton/reset-button.png"),
    CANCELLED: require("../../../../assets/images/iconButton/reset-button.png"),
    REJECTED: require("../../../../assets/images/iconButton/reset-button.png"),
  };

  const [waitData, setWaitData] = useState({
    waitTime: dataSend.waitTime,
    waitTimeDate: dataSend.waitTimeDate,
  });

  const endTime = moment().valueOf();
  const startTime = moment(dataSend.createdAt).valueOf();

  let msDifference = endTime - startTime;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function timeConvert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  const onWaitTimeEdit = async (id, time) => {
    try {
      let expReq = await amApi.patch(`/dataSend/${id}`, { waitTime: time });
      setWaitData({
        waitTime: expReq?.data?.waitTime,
        waitTimeDate: expReq?.data?.waitTimeDate,
      });
    } catch (err) {
      errorAlert("Something Went Wrong, try again later");
    }
  };

  const updatedTime = new Date(
    dataSend?.status === "PENDING"
      ? waitData?.waitTimeDate
      : dataSend?.reservationTime
  );
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime = waitData?.waitTime * 60 * 1000 || 0;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  useEffect(() => {
    if (viewOnScan) {
      setShowView(true);
    }
  }, [viewOnScan]);
  return (
    <>
      {!hidden && (
        <Button
          variant="link"
          className={`enIconBtn ${props?.overRideStyles ? "" : "mr-3"}`}
          onClick={() => handleShowView()}
          style={props?.overRideStyles}
        >
          <Image
            src={require("../../../../assets/images/UserManagement/eye.svg")}
            alt="View"
            title="View"
            fluid
          />
        </Button>
      )}
      <Modal
        show={showView}
        onHide={() => handleCloseView()}
        centered
        size="lg"
        backdrop="static"
        keyboard="false"
      >
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f24-700">View Guest Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className={`enGrayBorderBox mb-4`}>
            <Row className="px-3">
              <Col lg={3} md={6} xs={4} className="py-3 enLeftGReenLine">
                <div className="f12-500 pb-3">Name/Request Number</div>
                <div className="d-flex">
                  <div className="pl-2">
                    <div className="f15-500">{dataSend?.userDetails?.name}</div>
                    <div className="f9-400">#{dataSend?.requestId}</div>
                  </div>
                </div>
              </Col>
              <Col lg={2} md={6} xs={4} className="py-3">
                <div className="f12-500 pb-3">Total PAX</div>
                <div className="adult-total-box">
                  <div className="d-flex align-items-center">
                    <p className="f18-700 text-dark mr-2">
                      {dataSend?.adultCount +
                        dataSend?.kidsCount +
                        dataSend?.package?.adults +
                        dataSend?.package?.kids}
                    </p>
                    <div className="adult-total-box-two mr-2">
                      {dataSend?.adultCount + dataSend?.package?.adults ===
                      0 ? null : (
                        <div className="d-flex align-items-center justify-content-around mb-2">
                          <div className="adult-total-box-two-insideone">
                            <Image
                              src={require("../../../../assets/images/ActionImages/employees.png")}
                              fluid
                              alt="Adult"
                              title="Adult"
                              className="icon-image"
                            />
                          </div>
                          <span className="pl-1">
                            {dataSend?.adultCount + dataSend?.package?.adults}
                          </span>
                        </div>
                      )}
                      {dataSend?.kidsCount + dataSend?.package?.kids > 0 ? (
                        <div className="d-flex align-items-center justify-content-around">
                          <div className="adult-total-box-two-insideone">
                            <Image
                              src={require("../../../../assets/images/ActionImages/children.png")}
                              fluid
                              alt="Children"
                              title="Children"
                              className="icon-image"
                            />
                          </div>
                          <span className="pl-1">
                            {dataSend?.kidsCount + dataSend?.package?.kids}
                          </span>
                        </div>
                      ) : null}
                    </div>
                    <div className="adult-total-box-three">
                      {dataSend?.highchairCount === 0 ? null : (
                        <div className="d-flex align-items-center justify-content-around mb-2">
                          <div className="adult-total-box-three-insideone">
                            <Image
                              src={require("../../../../assets/images/ActionImages/highchair.png")}
                              fluid
                              alt="Wheel Chair"
                              title="Wheel Chair"
                              className="icon-image-small"
                            />
                          </div>
                          <span className="pl-1">
                            {dataSend?.highchairCount}
                          </span>
                        </div>
                      )}
                      {dataSend?.handicapCount === 0 ? null : (
                        <div className="d-flex align-items-center justify-content-around">
                          <div className="adult-total-box-three-insideone">
                            <Image
                              src={require("../../../../assets/images/ActionImages/wheelchair.png")}
                              fluid
                              alt="Highchair"
                              title="Highchair"
                              className="icon-image-small"
                            />
                          </div>
                          <span className="pl-1">
                            {dataSend?.handicapCount}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={2} xs={4} className="py-3">
                <div className="f12-500 pb-3">Payment Status</div>
                <div>
                  <span className="f12-500 d-flex align-items-center justify-content-center">
                    <i className="fa fa-inr mr-1" aria-hidden="true"></i>
                    <div className="d-flex ml-1 align-items-center">
                      {dataSend?.paymentData?.totalAmount} |{" "}
                      <div
                        className=" f10-500 ml-1"
                        style={{
                          color:
                            dataSend?.paymentStatus === 1
                              ? "#3E9121"
                              : "#EE3A23",
                        }}
                      >
                        {dataSend?.paymentStatus === 1
                          ? "PAID"
                          : dataSend?.paymentStatus === 0
                          ? "UNPAID"
                          : dataSend?.paymentStatus === 3
                          ? "FAILURE"
                          : "N/A"}
                      </div>
                    </div>
                  </span>
                  <hr className="my-1" />
                  {dataSend?.paymentStatus !== 1 ? (
                    dataSend?.status === "CANCELLED" ? (
                      ""
                    ) : (
                      <div className="mt-1 mb-1 text-center">
                        <button
                          className="btn bg-danger text-white f10-400 px-2 py-1"
                          onClick={
                            () => onClickPayLater ? onClickPayLater(): {}
                          }
                        >
                          Pay Now
                        </button>
                      </div>
                    )
                  ) : (
                    ""
                  )}
                  <div className="text-center">
                    <div className="f12-500">
                      {dataSend?.splitPayment ? (
                        <>Split Payment</>
                      ) : (
                        NEW_PAYMENT_TYPE[dataSend?.paymentData?.paymentMethod]
                      )}
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} xs={6} className="py-3">
                <div className="f12-500 pb-3">Date / Time</div>
                <div className="date-time-timer-body">
                  <ExpEditWaitTime
                    disabled={dataSend?.status === "PENDING"}
                    noDisplay={
                      <div className="timer-section">
                        <div className="f14-700" style={{ color: "#000000" }}>
                          <NewCountDown waitNew={diff} />
                        </div>
                      </div>
                    }
                    onWaitTimeEdit={onWaitTimeEdit}
                    id={dataSend?._id}
                  />
                </div>
                <p className="font_16_r">
                  {moment(dataSend?.reservationTime).format("Do MMM, YYYY")}
                </p>
                <p className="font_16_r">
                  {moment(dataSend?.reservationTime).format("hh:mm A")}
                </p>
              </Col>
              <Col lg={2} md={6} xs={6} className="py-3">
                <div className="f12-500 pb-3">Seating Preference</div>
                <div className="f12-400">{dataSend?.seatingPreference}</div>
              </Col>
            </Row>
            <hr className="m-0" />
            <Row className="px-3">
              <Col lg={3} md={6} xs={4} className="py-3">
                <div className="f12-500 pb-3">Request Date & Time</div>
                <div className="f12-400">
                  {moment(dataSend?.createdAt).format("Do MMM, YYYY")}
                </div>
                <div className="f12-400">
                  {moment(dataSend?.createdAt).format("hh:mm A")}
                </div>
              </Col>
              <Col lg={2} md={6} xs={3} className="py-3">
                <>
                  <div className="f12-500 pb-3 text-center">User Location</div>
                  <div className="">
                    <LocationReusable
                      dataSend={dataSend}
                      socket={props?.socket}
                      disabled={true}
                    />
                  </div>
                </>
              </Col>
              <Col lg={3} md={2} xs={5} className="py-3">
                <p className="f12-400 text-center">Total wait time</p>
                <div className="px-2" align="center">
                  <div className="enTimesLbl d-flex justify-content-center align-items-center">
                    <Image
                      src={require("../../../../assets/images/UserManagement/hourglass.svg")}
                      alt="Edit"
                      title="Edit"
                      width="10px"
                    />
                    <p className="f10-500 text-dark pl-2">
                      {timeConvert(minutes) || "00 hh : 00 min"}
                    </p>
                  </div>
                </div>
              </Col>
              {hidden && (
                <Col lg={4} md={4} xss={4} className="py-3 text-center">
                  <div
                    className={
                      true
                        ? "action-section-body d-flex align-items-center justify-content-center f10-500"
                        : "action-section-body align-items-center f10-500"
                    }
                  >
                    {(page === "booking" &&
                      moment(dataSend?.reservationTime).format("YYYY-DD-MM") ==
                        moment().format("YYYY-DD-MM") &&
                      btnData?.back) ||
                    (page !== "booking" && btnData?.back) ? (
                      <div className="d-flex flex-column mr-2" onClick={onBack}>
                        <Image
                          src={statusBackIcon[dataSend.status]}
                          height={`${
                            dataSend?.status === "PENDING" ? "38px" : "48px"
                          }`}
                        />
                        <div>{btnData?.back}</div>
                      </div>
                    ) : (
                      <></>
                    )}
                    <div className="middle-timer m-0 mx-3">
                      <div
                        className="seating-status py-2 px-4"
                        style={{
                          backgroundColor: `${
                            statusName[dataSend.status].background
                          }`,
                        }}
                      >
                        <p
                          className="font_16_m"
                          style={{
                            color: `${statusName[dataSend.status].color}`,
                          }}
                        >
                          {statusName[dataSend.status].name}
                        </p>
                      </div>
                      <div className="f9-400">{timeConvert(minutes)}</div>
                    </div>
                    {(page === "booking" &&
                      moment(dataSend?.reservationTime).format("YYYY-DD-MM") ==
                        moment().format("YYYY-DD-MM") &&
                      btnData?.next) ||
                    (page !== "booking" && btnData?.next) ? (
                      <div className="d-flex flex-column ml-2" onClick={onNext}>
                        <Image
                          src={require("../../../../assets/images/iconButton/Nextarrowgreen.svg")}
                          height="48px"
                        />
                        <div>{btnData?.next}</div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </Col>
              )}
            </Row>
            <hr className="m-0" />
            <Row className="px-3">
              <Col lg={3} md={6} xs={4} className="py-3">
                <div className="f12-500 pb-3">Seat No.</div>
                <div className="f12-400">Seat No. -</div>
                <div className="mt-4">
                  <div className="f12-500">More actions</div>
                  <div className="d-flex">
                    <Button
                      variant="link"
                      className="enIconBtn mt-3"
                      style={{ color: "black" }}
                      onClick={() => {
                        const win = window.open(
                          `/experience/ticket/${dataSend?._id}`,
                          "_blank"
                        );
                        win.focus();
                      }}
                    >
                      <i class="fa fa-print" aria-hidden="true"></i>
                    </Button>

                    <ShareButtonExpTicket data={dataSend} />
                  </div>
                </div>
              </Col>
              <Col lg={3} md={6} xs={4} className="py-3">
                <div className="f12-500 pb-3">Special Occasion</div>
                <div className="f12-400" style={{ wordBreak: "break-word" }}>
                  {dataSend?.occasion || "N/A"}
                </div>
              </Col>
              <Col xs={4} lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">Status</div>
                <div className="f13-400">
                  <span className="enYellowDot mr-1"></span>
                  {dataSend?.status}
                </div>
              </Col>
              <Col xs={4} lg={3} md={6} className="py-3">
                <div className="f12-500 pb-3">QR Code</div>
                <QRCode
                  bgColor="#FFFFFF"
                  fgColor="#000000"
                  level="H"
                  style={{ width: 120, height: 120 }}
                  // value={dataSend?.shareLink?.shortLink || dataSend?.requestId}
                  value={JSON.stringify({
                    expRequestId: dataSend?.requestId,
                  })}
                />
              </Col>
            </Row>
          </div>
          <div>
            <Button variant="link" className="f18-700 px-0 pb-3 text-dark">
              Details
            </Button>
          </div>
          <div className="enGrayBorderBox">
            <Row className="px-3">
              <Col xs={4} lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Phone Number</div>
                <div className="f15-400 pb-3 d-flex">
                  {dataSend?.userDetails?.countryCode + " "}
                  {dataSend?.userDetails?.mobileNumber?.replace(
                    /\d(?=\d{3})/g,
                    "*"
                  )}
                  {/* props.dataSend.user_details.country_code + " " +  */}
                </div>
              </Col>
              <Col xs={4} lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Request Number</div>
                <div className="f15-400 pb-3">#{dataSend?.requestId}</div>
              </Col>
              <Col xs={4} lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">User status</div>
                <div className="f15-400 pb-3">
                  {dataSend?.userConfirmed ? "Confirmed" : "Not Confirmed"}
                </div>
              </Col>
              <Col xs={4} lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Point of entry</div>
                <div className="f15-400">{dataSend?.pointOfEntry || "N/A"}</div>
              </Col>
            </Row>
            <hr className="m-0" />
            <Row className="px-3">
              <Col xs={4} lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Changed Date/Time</div>
                <div className="f15-400">
                  {moment(dataSend?.updatedAt).format("Do MMMM, YYYY")}
                </div>
                <div className="f15-400">
                  {moment(dataSend?.updatedAt).format("hh:mm A")}
                </div>
              </Col>

              <Col xs={4} lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Reason for Cancel/ Reject</div>
                <div className="f15-400">{dataSend?.cancelReason || "N/A"}</div>
              </Col>
            </Row>
            <hr className="m-0" />

            <div>
              <Button variant="link" className="f18-700 px-2 pb-3 text-dark">
                Ticket Details
              </Button>
            </div>
            <Row className="px-3">
              <Col xs={4} lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Ticket type</div>
              </Col>
              <Col xs={4} lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Count</div>
              </Col>
              <Col xs={4} lg={3} md={3} className="py-3">
                <div className="f12-500 pb-3">Ticket Price</div>
              </Col>
            </Row>
            {dataSend?.package?.count ? (
              <>
                <Row className="px-3">
                  <Col xs={4} lg={3} md={3} className="py-3">
                    <div className="f12-500 pb-3">
                      Package (
                      {`${
                        dataSend?.package?.adults / dataSend?.package?.count
                      }`}{" "}
                      Adults
                      {`${
                        dataSend?.package?.kids / dataSend?.package?.count
                          ? `, ${
                              dataSend?.package?.kids / dataSend?.package?.count
                            } Kids`
                          : ""
                      }`}
                      )
                    </div>
                  </Col>
                  <Col xs={4} lg={3} md={3} className="py-3">
                    <div className="f12-500 pb-3">
                      {" "}
                      {dataSend?.package?.count}
                    </div>
                  </Col>
                  <Col xs={4} lg={3} md={3} className="py-3">
                    <div className="f12-500 pb-3">
                      {dataSend?.package?.price}/-
                    </div>
                  </Col>
                </Row>
              </>
            ) : null}
            <>
              {dataSend?.adultCount > 0 ? (
                <Row className="px-3">
                  <Col xs={4} lg={3} md={3} className="py-3">
                    <div className="f12-500 pb-3">Adults</div>
                  </Col>
                  <Col xs={4} lg={3} md={3} className="py-3">
                    <div className="f12-500 pb-3"> {dataSend?.adultCount}</div>
                  </Col>
                  <Col xs={4} lg={3} md={3} className="py-3">
                    <div className="f12-500 pb-3">{dataSend?.adultPrice}/-</div>
                  </Col>
                </Row>
              ) : null}

              {dataSend?.kidsCount > 0 ? (
                <Row className="px-3">
                  <Col xs={4} lg={3} md={3} className="py-3">
                    <div className="f12-500 pb-3">Kids</div>
                  </Col>
                  <Col xs={4} lg={3} md={3} className="py-3">
                    <div className="f12-500 pb-3"> {dataSend?.kidsCount}</div>
                  </Col>
                  <Col xs={4} lg={3} md={3} className="py-3">
                    <div className="f12-500 pb-3">{dataSend?.kidsPrice}/-</div>
                  </Col>
                </Row>
              ) : null}
            </>
          </div>
          <h4 className="f16-500 my-4">Transaction Details</h4>
          <br />
          <div className="details-model-orders-view table-responsive enGrayBorderBox">
            <table className="table table-borderless">
              <thead style={{ marginBottom: "1%" }}>
                <tr>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Transaction ID
                  </th>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Amount
                  </th>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Payment Method
                  </th>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Payment Status
                  </th>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Payment Date / Time
                  </th>
                </tr>
              </thead>
              <tbody>
                {dataSend?.transactionDetails?.map((item, index) => (
                  <tr key={index}>
                    <td className="f12-400" style={{ width: "20%" }}>
                      {item?.txnId || item?._id}
                    </td>
                    <td
                      className="f14-500"
                      style={{
                        width: "20%",
                        color:
                          item?.type === "REFUND" && item?.paid
                            ? "#EE3A23"
                            : item?.type !== "REFUND" && item?.paid
                            ? "#1AB61E"
                            : "#EE3A23",
                        // item?.paid ? "#1AB61E" : "#EE3A23",
                      }}
                    >
                      <i class="fa fa-rupee"></i> {item?.amount.toFixed(2)}
                    </td>
                    <td className="f12-400" style={{ width: "20%" }}>
                      {item?.paymentType
                        ? NEW_PAYMENT_TYPE[item?.paymentType]
                        : "-"}
                    </td>
                    <td className="f12-400" style={{ width: "20%" }}>
                      {item?.type === "REFUND" && item?.paid
                        ? "Refund"
                        : item?.type !== "REFUND" && item?.paid
                        ? "Paid"
                        : "Unpaid"}
                      {/* {item?.paid ? "Paid1" : "Unpaid"} */}
                    </td>
                    <td className="f12-400" style={{ width: "20%" }}>
                      {moment(item?.date).format("Do MMMM YYYY, hh:mm a")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <br />
          <h4 className="f16-500">View Audit Log</h4>
          <br />
          <div className="details-model-orders-view table-responsive enGrayBorderBox">
            <table className="table table-borderless">
              <thead style={{ marginBottom: "1%" }}>
                <tr>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Date
                  </th>
                  <th className="f12-500" style={{ width: "70%" }}>
                    Operation
                  </th>
                  <th style={{ width: "15%" }}></th>
                </tr>
              </thead>
              {dataSend?.auditLogs?.map((item, index) => (
                <tbody key={index}>
                  <tr>
                    <td className="f11-500" style={{ width: "20%" }}>
                      {moment(item?.timestamp).format("Do MMM, YYYY")} <br />{" "}
                      {moment(item?.timestamp).format("LT")}
                    </td>
                    <td className="f11-500" style={{ width: "70%" }}>
                      {item?.message}
                    </td>
                    <td
                      className="f11-500"
                      style={{ width: "15%", textAlign: "right" }}
                    >
                      {item?.initiator}
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default ViewExpReqDetails;
